import { useCallback } from 'react';
import { useFormContext } from '../context/FormContext';
import { FormActionType } from '../context/formReducer';

// Hook for UI-related operations
export function useUIOperations() {
  const { state, dispatch } = useFormContext();

  // Extract UI-related state
  const {
    snackbarOpen,
    snackbarMessage,
    snackbarSeverity,
    snackbars,
    deleteConfirmOpen,
    deleteItemType,
    itemToDelete,
  } = state;

  // Show snackbar
  const showSnackbar = useCallback(
    (message: string, severity: typeof snackbarSeverity) => {
      dispatch({
        type: FormActionType.SHOW_SNACKBAR,
        payload: { message, severity },
      });
    },
    [dispatch],
  );

  // Hide snackbar
  const hideSnackbar = useCallback(
    (id?: string) => {
      dispatch({
        type: FormActionType.HIDE_SNACKBAR,
        ...(id ? { payload: { id } } : {}),
      });
    },
    [dispatch],
  );

  return {
    // State
    snackbarOpen,
    snackbarMessage,
    snackbarSeverity,
    snackbars,
    deleteConfirmOpen,
    deleteItemType,
    itemToDelete,

    // Handlers
    showSnackbar,
    hideSnackbar,
  };
}
